import { render, staticRenderFns } from "./LayoutContent.vue?vue&type=template&id=28b26d9a&scoped=true"
import script from "./LayoutContent.vue?vue&type=script&lang=js"
export * from "./LayoutContent.vue?vue&type=script&lang=js"
import style0 from "./LayoutContent.vue?vue&type=style&index=0&id=28b26d9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b26d9a",
  null
  
)

export default component.exports